<template>
	<div class="hit-container">

		<div class="hit-row">

			<div class="hit-col-md-4" v-for="(entry, index) in blog">
				<div class="hit-panel hit-panel-primary">

					<div class="hit-panel-heading">

						{{ entry.title }}

					</div>

					<div class="hit-panel-body" v-html="entry.content" />

					<div class="hit-panel-footer">

						<span class="hit-pull-right">
							<router-link class="hit-html-a" :to="{ name: 'blogpost', params: {lang: $store.getters.lang, id: index, title: deUmlaut(entry.title) } }" >Weiterlesen...</router-link>
						</span>
						<div class="hit-clearfix" />
					</div>

				</div>
			</div>

		</div>
	</div>
</template>

<script>
export default{
  name: 'blog',

  data: function () {
    return {
      blog: []
    }
  },
  methods: {

    get_blogs: function () {
      this.blog = [
        {title: 'Testeintrag 1', content: 'Hier kommt dann der Text'},
        {title: 'Testeintrag 2', content: 'Auch ein schöner Text'}
      ]
    },

    deUmlaut: function (value) {
			  value = value.toLowerCase()
			  value = value.replace(/ä/g, 'ae')
			  value = value.replace(/ö/g, 'oe')
			  value = value.replace(/ü/g, 'ue')
			  value = value.replace(/ß/g, 'ss')
			  value = value.replace(/ /g, '-')
			  value = value.replace(/\./g, '')
			  value = value.replace(/,/g, '')
			  value = value.replace(/\(/g, '')
			  value = value.replace(/\)/g, '')

			  return value
    }

  },
  mounted: function () {
    this.get_blogs()
  }
}
</script>
